export default __webpack_public_path__ + "static/media/KZ.T.06.2204.79f7d4db.svg";